import { AxiosResponse } from "axios";
import { MutationBasicaParam, QueryBasicaParam } from "../../../Utils/RequisicaoUtilitario";
import { CorrecaoContabil } from "../../../Models/Domain/Viagem/Financeiro/CorrecaoContabil";
import { Axios } from "../../Axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ViagemFechada } from "../../../Models/Domain/Viagem/ViagemFecahmento";
import { queryClient } from "../../../App";
import TypeViagem from "@/Models/Domain/Viagem/Viagem";

export function useViagemFehamentoListarContas({
    codViagem,
    ...rest
}:QueryBasicaParam<AxiosResponse<CorrecaoContabil[]>, CorrecaoContabil[], {
    codViagem:number;
}>) {
    return useQuery({
        ...rest,
        queryKey : [ "Viagem", "ViagemFechada", "Contas", "Listar", `Viagem.${codViagem}` ],
        queryFn : () => Axios.get<CorrecaoContabil[]>(`viagem/${codViagem}/viagemFechada/contas`),
        select(data) {
            return data.data.map(item => {
                item.dataCriacao = new Date(item.dataCriacao as any);
                item.dataPagamento = new Date(item.dataPagamento as any);
                return item;
            });            
        },
        staleTime : 1000 * 60 * 0 // 0 Minuto
    });
}

export function useViagemFechamentoObter({
    codViagem,
    ...rest
}:QueryBasicaParam<AxiosResponse<ViagemFechada>, ViagemFechada, {
    codViagem:number;
}>) {
    return useQuery({
        ...rest,
        queryKey : ["Viagem", "ViagemFechada", "ObterComValores", `Viagem.${codViagem}`],
        queryFn : () => Axios.get<ViagemFechada>(`viagem/${codViagem}/viagemFechada/fechamento`),
        select(data) {            
            data.data.dataCriacao = new Date(data.data.dataCriacao as any);

            return data.data;
        },
        staleTime : 1000 * 60 * 0 // 0 Minuto
    });
}

export interface IViagemFechadaInserirParam {
    viagemFechada:ViagemFechada;
    atualizarNota:boolean;
}

export function useViagemFechadaInserir({
    onSuccess,
    ...rest
}:MutationBasicaParam<IViagemFechadaInserirParam, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {            
            return Axios.post(`viagem/${dataRequest.viagemFechada.codViagem}/viagemfechada/${dataRequest.atualizarNota ?? true}`, dataRequest.viagemFechada);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Viagem", "ViagemFechada", "ObterComValores", `Viagem.${entrada.viagemFechada.codViagem}`] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export interface IViagemFechadaCancelarParam {
    viagem:TypeViagem;
    cancelarNota:boolean;
}

export function useViagemFechadaCancelar({
    onSuccess,
    ...rest
}:MutationBasicaParam<IViagemFechadaInserirParam, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {            
            return Axios.post(`viagem/${dataRequest.viagemFechada.codViagem}/viagemfechada/cancelar/${dataRequest.atualizarNota ?? true}`, dataRequest.viagemFechada.viagem);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Viagem", "ViagemFechada", "ObterComValores", `Viagem.${entrada.viagemFechada.codViagem}`] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}